import { initFederation } from '@angular-architects/native-federation';
import { environment } from '@env/environment';

async function bootstrapApp() {
  await initFederation({
    'ventamp-ms-front': environment.MF_VENTA_REMOTE,
  });

  await import('./bootstrap');
}

bootstrapApp(); //NOSONAR
